import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=b43e9cfc&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"
import style0 from "./Inquiry.vue?vue&type=style&index=0&id=b43e9cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43e9cfc",
  null
  
)

export default component.exports